export function isMiniChartLabelTruncated(element, index) {
  const label = element.querySelectorAll(".mini-chart-label, .mini-chart-label-standard")[index]
  return !!label && label.scrollWidth > label.clientWidth
}

export function handleMiniChartKeydown(event, countData, selectChart) {
  if (event.key !== "Enter" && event.key !== " ") {
    return
  }

  event.preventDefault()
  selectChart(countData)
}
